import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useTranslation } from "@/hooks/useTranslation";

type ConversationCloseDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCloseAndForget: () => void;
  onCloseAndRemember: () => void;
};

export function ConversationCloseDialog({
  open,
  onOpenChange,
  onCloseAndForget,
  onCloseAndRemember,
}: ConversationCloseDialogProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(
              "team.components.instruction.conversation.closeConfirm.title"
            )}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              "team.components.instruction.conversation.closeConfirm.description"
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-between">
          <AlertDialogCancel>
            {t(
              "team.components.instruction.conversation.closeConfirm.cancel"
            )}
          </AlertDialogCancel>
          <div className="flex gap-2">
            <AlertDialogAction
              variant="destructive"
              onClick={onCloseAndForget}
            >
              {t(
                "team.components.instruction.conversation.closeConfirm.closeAndForget"
              )}
            </AlertDialogAction>
            <AlertDialogAction variant="default" onClick={onCloseAndRemember}>
              {t(
                "team.components.instruction.conversation.closeConfirm.closeAndRemember"
              )}
            </AlertDialogAction>
          </div>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
